// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1RIFT","file":"styles_file__3M8I9"};